<template>
  <q-banner
    v-for="error in errors"
    :key="error"
    dense
    rounded
    v-bind="$attrs"
  >
    <template #avatar>
      <q-icon name="mono-exclamation-hexagon-solid" />
    </template>
    {{ error }}
  </q-banner>
</template>

<script setup>
defineOptions({ name: 'SanFormErrorBanner' })
const props = defineProps({
  errors: { type: Object, default: () => ({}) }
})
</script>
